import React, { FC } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import { isEmpty, map } from 'lodash';
import { useSelector } from 'react-redux';

import {
  DetailsIdentifier,
  EllipsisText,
  renderRiskContextIcon,
} from 'components/DataDisplay';
import { useGetDescription } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/hooks/useGetDescription';
import { renderMetadataDrawerAlertCount } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/utils';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { useCloudAccountId } from 'containers/Setup/CloudAccounts/utils';

export const AwsSummary: FC = () => {
  const {
    resourceInsight,
    resourceSeverity,
    resourceDetails,
    riskContext,
  } = useSelector(selectActiveResource);
  const { data: insight } = resourceInsight;
  const { data: severity } = resourceSeverity;
  const { renderAccountWithVPCAndRegion } = useCloudAccountId();

  const { getDescription } = useGetDescription();

  return (
    <Stack spacing={4}>
      <HStack align="flex-start" spacing={6}>
        <Box w="50%">
          <DetailsIdentifier
            label="Cloud ID"
            isLoading={resourceInsight.isLoading}
            value={<EllipsisText>{insight?.resource_id}</EllipsisText>}
          />
        </Box>
        <Box w="50%">
          <DetailsIdentifier
            label="Issues"
            value={renderMetadataDrawerAlertCount(severity)}
          />
        </Box>
      </HStack>
      <HStack align="flex-start" spacing={6}>
        <Box w="50%">
          <DetailsIdentifier
            isLoading={resourceInsight.isLoading}
            label="Deployed In"
            value={renderAccountWithVPCAndRegion(insight)}
          />
        </Box>
        <Box w="50%">
          <DetailsIdentifier label="Tickets" />
        </Box>
      </HStack>
      <HStack align="flex-start" spacing={6}>
        <Box w="50%">
          <DetailsIdentifier
            label="Risk Context"
            align="center"
            isLoading={riskContext.isLoading}
            spacing={4}
            value={
              isEmpty(riskContext.data) ? (
                'None'
              ) : (
                <HStack spacing={0}>
                  {map(riskContext.data, (o, index) => (
                    <Box key={index + '-risk-context'}>
                      {renderRiskContextIcon(o)}
                    </Box>
                  ))}
                </HStack>
              )
            }
          />
        </Box>
        <Box w="50%">
          <DetailsIdentifier
            label="Description"
            isLoading={resourceInsight.isLoading || resourceDetails.isLoading}
            value={getDescription()}
          />
        </Box>
      </HStack>
    </Stack>
  );
};
